import { Revision } from "./revision";

export interface Doc {
  id: string;
  title: string;
  gcsRefId: string;
  revisions: Revision[]
}
